import { Link } from "react-router-dom";
import type { ProductDto } from "@gaole/shared";
import { rm } from "../../lib/format";
import { ProductImage } from "../ProductCard";
import { Countdown } from "../Countdown";
import { Badge } from "../ui";

export function AuctionCard({
  auction,
}: {
  auction: {
    id: string;
    title: string;
    status: string;
    endsAt: string;
    currentBid?: number;
    currentPrice?: number;
    bidCount: number;
    product: ProductDto;
    leading?: boolean;
    isLeading?: boolean;
  };
}) {
  const price = auction.currentBid ?? auction.currentPrice ?? 0;
  const leading = auction.leading ?? auction.isLeading;
  return (
    <Link
      to={`/auctions/${auction.id}`}
      className="flex w-full min-w-0 items-center gap-3 rounded-2xl border border-white/5 bg-surface p-3 transition-all active:scale-[0.99] lg:hover:-translate-y-0.5 lg:hover:border-brand-blue/30"
    >
      <ProductImage src={auction.product.images[0] ?? null} alt="" className="h-14 w-14 shrink-0 rounded-xl" />
      <div className="grid min-w-0 flex-1 grid-cols-[minmax(0,1fr)_auto] items-center gap-x-3 gap-y-1">
        <div className="min-w-0">
          <p className="truncate text-xs font-semibold">{auction.title}</p>
          <p className="mt-0.5 font-display text-sm font-bold text-brand-pink">{rm(price)}</p>
          <p className="text-[10px] text-white/45">{auction.bidCount} bids</p>
        </div>
        <div className="flex shrink-0 flex-col items-end gap-1">
          {leading ? <Badge color="blue">Leading</Badge> : null}
          <Countdown target={auction.endsAt} compact neon />
        </div>
      </div>
    </Link>
  );
}
